import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const KNOWN_REASONS = [
  'EXPLICIT_REQUEST',
  'LOW_CONFIDENCE',
  'LOOP_DETECTED',
  'POLICY_TOPIC',
  'AGENT_ESCALATED',
  'AI_UNAVAILABLE',
  'NO_TEMPLATE',
] as const;

export interface EscalationReasonChipProps {
  /** Additive-only on the wire (domain-conversation) — an unknown code renders in mono, never crashes. */
  reason: string;
  size?: 'small' | 'medium';
}

/** The seven-reason chip shared by the inbox row, the detail's escalation panel and Customer 360. */
export function EscalationReasonChip({ reason, size = 'small' }: EscalationReasonChipProps) {
  const { t } = useTranslation('conversations');
  const known = (KNOWN_REASONS as readonly string[]).includes(reason);
  const label = known ? t(`reasons.${reason}.label`) : reason;
  const tooltip = known
    ? t(`reasons.${reason}.tooltip`)
    : t('reasons.unknownTooltip', { code: reason });

  return (
    <Tooltip title={tooltip} describeChild>
      <Chip
        size={size}
        variant="outlined"
        label={label}
        sx={known ? undefined : { fontFamily: 'JetBrains Mono, monospace' }}
      />
    </Tooltip>
  );
}
